<template>
    <div id="page-login">
        <div class="login__container">
            <div class="container__header"><h3>GESTAON ERP</h3></div>
            <div class="container__body" v-if="keyState === 'invited'">
                <div style="margin-right: 150px; max-width: 450px">
                    <small>Ainda não possuí uma conta? Cadastre-se aqui!</small>
                    <br><br>
                    <form autocomplete="off">
                        <div>
                            <label>Nome</label> <input style="display:none;" />
                            <input type="text" name="nome" v-validate="'required|min:3'" class="input" placeholder="Digite seu nome" autocomplete="off" v-model="formRegister.name" />
                            <small style="color: tomato;"> {{ errors.first('nome') }} </small>
                        </div>
                        <div>
                            <label>E-mail</label> <input style="display:none;" />
                            <input type="email" name="email" v-validate="'required'" class="input" placeholder="Digite seu email" autocomplete="off" v-model="formRegister.email" />
                            <small style="color: tomato;"> {{ errors.first('email') }} </small>
                        </div>
                        <div>
                            <label>Senha</label> <input style="display:none;" />
                            <input type="password" name="senha" v-validate="'required|min:6'" class="input" placeholder="*******" autocomplete="off" v-model="formRegister.password" />
                            <small style="color: tomato;"> {{ errors.first('senha') }} </small>
                        </div>
                        <div>
                            <label>Confirmar senha</label> <input style="display:none;" />
                            <input type="password" name="confirmar senha" v-validate="'required|min:6'" class="input" placeholder="*******" autocomplete="off" v-model="formRegister.confirmPassword" />
                            <small style="color: tomato;"> {{ errors.first('confirmar senha') }} </small>
                        </div>
                        <div style="margin-top: 20px;">
                            <button class="btn" @click.prevent="register()">Cadastrar</button>
                        </div>
                    </form>
                </div>
                
                <div id="login">
                    <small>Já possuí uma conta? Faça login aqui!</small>
                    <br><br>
                    <form autocomplete="off">
                        <div style="text-align: right;">
                            <label>E-mail</label> <input style="display:none;" class="input-login" />
                            <input type="email" class="input" placeholder="Digite seu email" autocomplete="off" v-model="form.email" />
                        </div>
                        <div style="text-align: right;">
                            <label>Senha</label> <input style="display:none;" />
                            <input type="password" class="input" placeholder="*******" autocomplete="off" v-model="form.password" />
                        </div>
                        <div style="margin-top: 20px;">
                            <button class="btn" @click.prevent="login">entrar</button>
                        </div>
                    </form>
                    <div class="body__action-buttons">
                        <a href="#">esqueci minha senha</a>
                    </div>
                </div>

            </div>
            <div class="container__body" v-else-if="keyState === 'loading'">
                <div style="font-weight: 600; font-size: 1.5em;">
                    Carregando convite...
                </div>
            </div>
            <div class="container__body" v-else>
                <div v-if="keyState === 'invalid'" style="font-weight: 600; font-size: 1.5em; color: tomato;">
                    Convite inválido!
                </div>
                <div v-if="keyState === 'expired'" style="font-weight: 600; font-size: 1.5em; color: tomato;">
                    Convite expirado :/!
                </div>
                <div v-if="keyState === 'accepted'" style="font-weight: 600; font-size: 1.5em; color: green;">
                    Esse convite já foi aceito :)!
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from "vuex";
    import UsersAPI from '../../api/users'
    import CompanyUserInvitesAPI from '../../api/company-user-invites'

    export default {
        data() {
            return {
                form: {
                    email: "",
                    password: ""
                },
                formRegister: {
                    name: '',
                    email: '',
                    password: '',
                    confirmPassword: ''
                },
                keyState: 'loading'
            };
        },
        computed: {
            ...mapState("auth", ["isAuthenticated", 'user'])
        },
        methods: {
            ...mapActions("auth", ["authenticate", 'authenticateOffline']),
            ...mapActions("toast", ["showToast", 'showError']),
            async login() {
                const vm = this;
                window.showAppLoading();
                window.setAppLoadingText("Aceitando convite...")
                setTimeout(() => {
                    vm.authenticate(vm.form).then(() => {
                        CompanyUserInvitesAPI.acceptInvite(this.$route.params.inviteKey, {
                            email: this.user.email,
                            password: this.user.password
                        })
                        .then((res) => {
                            window.setAppLoadingText("Sucesso! Aguarde...")
                            if (vm.isAuthenticated) {
                                vm.$router.replace("/")
                                this.$emit('destroyComponent', false)
                            }
                        })
                        .catch(err => {
                            console.log(err)
                            window.removeAppLoading()
                            this.showError(err.body.message)
                            CompanyUserInvitesAPI.validateKey(this.$route.params.inviteKey)
                                .then((res) => this.keyState = res.data)
                        })  
                    }).catch(error => {
                        console.log(error)
                        window.removeAppLoading()
                        if(error.status === 0){
                            vm.showToast({
                                type: "error",
                                message: "Verifique sua conexão com a Internet ou a disponibilidade do servidor"
                            })
                            return
                        }
                        vm.showToast({
                            type: "error",
                            message: error.data.message
                        })
                    })
                },1000)
            },

            async register() {
                if(!this.formRegister.name || !this.formRegister.email || !this.formRegister.password || !this.formRegister.confirmPassword)
                    return this.showError('Preencha os campos')

                this.errors.all().forEach(error => {
                    this.showError(error)
                })
                if(this.errors.all().length) return

                if(this.formRegister.password !== this.formRegister.confirmPassword)
                    return this.showError('As senhas estão diferentes.')

                window.showAppLoading();
                window.setAppLoadingText("Criando conta e aceitando convite...")
                setTimeout(() => {
                        UsersAPI.register({
                            name: this.formRegister.name,
                            email: this.formRegister.email,
                            password: this.formRegister.password
                        })
                        .then((res) => {
                            this.authenticateOffline(res.data)
                            CompanyUserInvitesAPI.acceptInvite(this.$route.params.inviteKey, {
                                email: this.user.email,
                                password: this.user.password
                            })
                            .then((res) => {
                                window.setAppLoadingText("Sucesso! Aguarde...")
                                if (this.isAuthenticated) {
                                    this.$router.replace("/")
                                    this.$emit('destroyComponent', false)
                                }
                                window.removeAppLoading()
                            })
                            .catch(err => {
                                console.log(err)
                                window.removeAppLoading()
                                this.showError(err.body.message)
                                CompanyUserInvitesAPI.validateKey(this.$route.params.inviteKey)
                                    .then((res) => this.keyState = res.data)
                            })  
                        })
                        .catch((err) => {
                            window.removeAppLoading()
                            this.showError(err.body.message)
                        })
                }, 1000)
            },
        },
        async mounted() {
            console.log(this.$route.params.inviteKey)
            await CompanyUserInvitesAPI.validateKey(this.$route.params.inviteKey)
                .then((res) => this.keyState = res.data)

            if(window.isAppLoading()){
                setTimeout(() => {
                    window.removeAppLoading()
                }, 1000)
            }
        }
    };
</script>

<style scoped>
    #page-login {
        background: transparent url("../../assets/imgs/bg-login.jpg") no-repeat center;
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: fixed;
        align-items: center;
    }

    #login .input {
        text-align: right;
    }

    ::placeholder {
        text-transform: lowercase;
    }

    /* Login Page */
    #page-login input {
        text-transform: uppercase;
        font-size: 24px;
    }

    #page-login input[type="email"] {
        text-transform: lowercase;
    }

    #page-login div.login__container {
        background-size: cover;
        background-position: center;
        width: 900px;
        display: flex;
        flex-direction: column;
        border-radius: 5px;
        box-shadow: 0 0 60px rgba(0, 0, 0, 0.4);
        background-color: rgba(15, 15, 15, 0.9);
        flex-shrink: 0;
        justify-content: center;
        align-items: center;
        padding: 40px;
    }

    #page-login div.login__container h3 {
        display: none;
        margin: 0;
        text-align: center;
        font-size: 30px;
        font-weight: 600;
    }

    #page-login div.login__container .container__header {
        background-image: url("../../assets/imgs/logo-white.png");
        background-size: cover;
        background-position: center;
        justify-content: center;
        align-items: center;
        width: 241px;
        height: 64px;
        color: #fff;
        text-align: center;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
    }

    #page-login div.login__container .container__header h3 {
        color: rgba(255, 255, 255, 0.9);
        text-shadow: 1px 1px #222;
    }

    #page-login div.login__container .container__header .btn {
        margin: 10px 0;
    }

    #page-login div.login__container .container__header small {
        color: rgba(255, 255, 255, 0.7);
    }

    #page-login div.login__container .container__body {
        flex-shrink: 0;
        padding: 40px 30px 20px;
        color: #333;
        text-align: center;
        display: flex;
        /* flex-direction: column; */
        flex-grow: 1;
        align-items: center;
    }

    #page-login div.login__container .container__body form {
        margin-bottom: 20px;
    }

    #page-login div.login__container .container__body form > div {
        margin-bottom: 20px;
        text-align: left;
    }

    #page-login div.login__container .container__body form > div label {
        color: #fff;
        font-weight: 600;
    }

    #page-login div.login__container .container__body form input.input {
        margin-bottom: 5px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    }

    input.input::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: rgba(255, 255, 255, 0.5);
    }

    input.input::-moz-placeholder {
        /* Firefox 19+ */
        color: rgba(255, 255, 255, 0.5);
    }
    input.input:-ms-input-placeholder {
        /* IE 10+ */
        color: rgba(255, 255, 255, 0.5);
    }
    input.input:-moz-placeholder {
        /* Firefox 18- */
        color: rgba(255, 255, 255, 0.5);
    }

    #page-login div.login__container .container__body .body__action-buttons {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    #page-login div.login__container .container__body .btn {
        margin: 0;
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
    }

    #page-login div.login__container .container__body a {
        text-align: center;
        color: rgba(255, 255, 255, 0.7);
    }

    #page-login .input,
    #page-login .textarea,
    #page-login .btn {
        height: 40px;
    }

    #page-login .control small {
        margin-top: 5px;
        font-size: 10px;
        color: #666;
        display: inline-block;
        line-height: 100%;
    }

    .btn {
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.4);
        background-color: rgba(255, 255, 255, 0.7);
        color: var(--font-color--primary);
        font-weight: 600;
        text-transform: uppercase;
        font-size: 14px;
    }
</style>
